import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Form, Badge, Stack } from 'react-bootstrap';
import DashMedidasButton from './DashMedidasButton/DashMedidasButton';
import { NotifyModal } from '../../../components/NotifyModal/NotifyModal';
import { FaSave, FaCog, FaEdit, FaCheck, FaTimes, FaWifi, FaDownload } from 'react-icons/fa';
import useBrazilianCurves from '../../../hooks/useBrazilianCurves';
import DashMedidasSectionCard from './DashMedidasSectionCard/DashMedidasSectionCard';

import Conected from '../../../components/Conected/Conected';
import ApiGServer from '../../../services/ApiGServer';
import ApiMServer from '../../../services/ApiMServer';
import Api from '../../../services/Api';
import './EditarEquipamentos.css';

const checkboxFieldMap = [
  { key: "tray", label: "Bandeja", fallback: "bandeja" },
  { key: "full_tracking", label: "Rastreamento completo", fallback: "rastreamentoCompleto" },
  { key: "scan_face", label: "Foto facial ao ativar", fallback: "fotoFacial" },
];

const allowedCompanyIdsFromEnv = (process.env.REACT_APP_COMPANYID || "")
  .split(",")
  .map((value) => value.trim())
  .filter(Boolean);

const createEmptyEquipamento = () => ({
  nameEquipament: "",
  dcal: "",
  mscal: "",
  flagcert: false,
  isentkey: false,
  lat: "",
  lng: "",
  daystoactivate: "",
  mode: "",
  serialnumber: "",
  equipid: "",
  cupid: "",
  versaosw: "",
  versaofwpri: "",
  versaofwosc: "",
  sha1curva: "",
  serialnumbersequence: "",
  wf: "",
  calph: "",
  curva: "",
  full_tracking: false,
  scan_face: false,
  tray: false
});

const normalizeBooleanValue = (value) => {
  if (value === undefined || value === null) {
    return false;
  }

  if (typeof value === "boolean") {
    return value;
  }

  if (typeof value === "number") {
    return value !== 0;
  }

  const normalized = `${value}`.trim().toLowerCase();
  return ["1", "true", "s", "sim", "ok", "yes"].includes(normalized);
};

const getCheckboxBoolean = (data, key, fallback) => {
  if (key in data) {
    return normalizeBooleanValue(data[key]);
  }

  if (fallback && fallback in data) {
    return normalizeBooleanValue(data[fallback]);
  }

  return false;
};

const mergeEquipamentoData = (data = {}) => {
  const filled = { ...createEmptyEquipamento(), ...data };

  checkboxFieldMap.forEach(({ key, fallback }) => {
    filled[key] = getCheckboxBoolean(data, key, fallback);
  });

  return filled;
};

const EditarEquipamentos = ({ user, id, empresaId, permissionSGU, localEquipament }) => {

  const navigate = useNavigate();

  const [modalShow, setModalShow] = useState(false);
  const [type, setType] = useState({ "color": "", "status": "" });
  const [, setLoading] = useState(true);

  const [access, setAccess] = useState(false);
  const [remoteAccessEnabled, setRemoteAccessEnabled] = useState(false);
  const originalEquipamentoRef = useRef(createEmptyEquipamento());

  const [equipamento, setEquipamento] = useState(createEmptyEquipamento());

  const [local, setLocal] = useState({
    companyId: empresaId || "",
    newLocalEquipament: {
      _id: localEquipament?._id,
      serial: id,
      localName: localEquipament?.localName || ""
    }
  });

  const { brazilianCurves, loading: curvesLoading, source: curvesSource, error: curvesError } =
    useBrazilianCurves(id);

  const currentCompanyId = empresaId || "";
  const serialNumberForCondition = equipamento?.serialnumber || id || "";
  const showTrayAndTrackingCheckboxes = Boolean(
    currentCompanyId &&
    allowedCompanyIdsFromEnv.includes(`${currentCompanyId}`) &&
    serialNumberForCondition.includes("BIMT")
  );

  const handleNameChange = (event) => {
    const value = event.target.value;
    setEquipamento((prev) => ({ ...prev, nameEquipament: value }));
    setLocal((prev) => ({
      ...prev,
      newLocalEquipament: { ...prev.newLocalEquipament, localName: value }
    }));
  };

  const handleNavigation = (path) => navigate(path);

  const toggleFeature = (featureKey) => {
    setEquipamento((prev) => ({ ...prev, [featureKey]: !prev[featureKey] }));
  };

  const getChangedFields = () => {
    const original = originalEquipamentoRef.current || {};
    const changes = {};

    Object.entries(equipamento).forEach(([key, value]) => {
      if (original[key] !== value) {
        changes[key] = value;
      }
    });

    return Object.keys(changes).length ? changes : null;
  };

  const handleStatusEquipamento = async () => {
    try {
      const { data } = await Api.post(`/connection/connected`, { filter: [id] });
      if (data.length > 0 && data.includes(id)) {
        setAccess(true);
      } else {
        setAccess(false);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const getEquipamento = async () => {
    try {
      let { data } = await ApiGServer.get(`/equipment/v1/${id}`);
      if (data) {
        const filledEquipamento = mergeEquipamentoData(data);
        setEquipamento(filledEquipamento);
        originalEquipamentoRef.current = { ...filledEquipamento };
      } else {
        const emptyEquipamento = createEmptyEquipamento();
        setEquipamento(emptyEquipamento);
        originalEquipamentoRef.current = { ...emptyEquipamento };
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false)
    }
  }

  const handleUpdateLocal = async () => {
    if (local?.newLocalEquipament?.serial) {
      try {
        await ApiMServer.post(`/company/addlocalequip`, local);
        setType({ color: "#198754", status: "Atualizado com sucesso!" });
        setModalShow(true);
      } catch (error) {
        console.log(error.message);
      }
    } else {
      alert("Parâmetros ausentes");
    }
  };

  const handleUpdateEquipment = async () => {
    const changedFields = getChangedFields();
    if (!changedFields) {
      // setType({ color: "#ffc107", status: "Nenhuma alteração detectada!" });
      // setModalShow(true);
      return;
    }

    const serial = equipamento.serialnumber || id;

    try {
      const { data } = await ApiGServer.patch(`/equipment/update`, {
        serialnumber: serial,
        ...changedFields
      });

      setEquipamento(data);
      originalEquipamentoRef.current = { ...data };
      setType({ color: "#198754", status: "Atualizado com sucesso!" });
      setModalShow(true);
    } catch (error) {
      console.log(error.message);
      setType({ color: "#dc3545", status: "Erro ao atualizar equipamento!" });
      setModalShow(true);
    }
  }

  const handleCertificateDownload = async () => {
    try {
      const serial = equipamento.serialnumber || id;
      const cupId = equipamento.cupid;

      console.log(serial, cupId);

      if (!serial || !cupId) {
        setType({ color: "#dc3545", status: "Número de série ou ID do copo indisponíveis!" });
        setModalShow(true);
        return;
      }

      const response = await ApiMServer.get(`/equipment/certificate/${serial}-${cupId}`, {
        responseType: 'blob'
      });

      const contentType = response.headers['content-type'];
      const isPdf = contentType && contentType.includes('application/pdf');
      const extension = isPdf ? 'pdf' : 'html';

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `certificado-${serial}.${extension}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Erro ao baixar certificado", error);
      setType({ color: "#dc3545", status: "Erro ao baixar certificado!" });
      setModalShow(true);
    }
  };

  useEffect(() => {
    getEquipamento();
    handleStatusEquipamento();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const InfoRow = ({ label, value, truncate = false }) => {
    if (!value && value !== 0) return null;
    return (
      <div className={`info-row ${truncate ? 'text-truncate' : ''}`}>
        <span className="info-label">{label}</span>
        <span className="info-value">{value}</span>
      </div>
    );
  };

  const socketBadge = (
    <Badge
      bg={access ? "success" : "secondary"}
      className="d-flex align-items-center gap-1 px-2 py-1"
    >
      <FaWifi /> Socket {access ? "Online" : "Offline"}
    </Badge>
  );

  return (
    <div className="editar-equipamentos dash-medidas-stack">
      <DashMedidasSectionCard
        icon={FaEdit}
        subtitle="Configuração"
        title="Editar Equipamento"
        headerRight={socketBadge}
        className="editar-equipamentos-card"
        collapsible
        sectionId="dash-editar-equipamento"
      >
        <div className="dash-section-card__content-stack">
          <NotifyModal
            type={type}
            show={modalShow}
            onHide={() => setModalShow(false)}
          />

          <Row className="dash-medidas-grid">
            <Col xs={12} md={6}>
              <Form.Group className="editar-form-group">
                <Form.Label className="fw-bold text-secondary mb-1">Nome do Equipamento / Local</Form.Label>
                <Form.Control
                  className='shadow-sm editar-input'
                  type="text"
                  maxLength={40}
                  placeholder="Ex: Silo Central / Área Norte"
                  aria-describedby="equipamentoNameHelp"
                  onChange={handleNameChange}
                  value={equipamento.nameEquipament}
                  disabled={!permissionSGU?.home?.write}
                  size='sm'
                />
                <Form.Text id="equipamentoNameHelp" className="text-muted fs-7">Máximo de 40 caracteres. O nome fica visível na lista e no mapa.</Form.Text>
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <div className="feature-checkboxes">
                {checkboxFieldMap
                  .filter(({ key }) => {
                    if (["tray", "full_tracking"].includes(key) && !showTrayAndTrackingCheckboxes) {
                      return false;
                    }
                    return true;
                  })
                  .map(({ key, label }) => (
                    <Form.Check
                      key={key}
                      type="checkbox"
                      id={`${key}-checkbox`}
                      label={label}
                      className="editar-checkbox"
                      checked={!!equipamento[key]}
                      onChange={() => toggleFeature(key)}
                      disabled={!permissionSGU?.home?.write}
                    />
                  ))}
              </div>
            </Col>
            {id?.includes("SEMT") && (
              <Col xs={12} md={6}>
                <Form.Group controlId="curvaSelect" className="editar-form-group">
                  <Form.Label className="section-subtitle mb-1">Curva do equipamento</Form.Label>
                  <Form.Select
                    className='shadow-sm editar-select'
                    onChange={(event) => {
                      equipamento.curva = event.target.value;
                      setEquipamento({ ...equipamento });
                    }}
                    disabled={!permissionSGU?.home?.write || curvesLoading}
                    size='sm'
                    value={equipamento?.curva || ""}
                  >
                    <option value="">
                      {curvesLoading ? "Carregando curvas..." : "Selecione a curva"}
                    </option>
                    {brazilianCurves.map((curva) => (
                      <option key={curva.id} value={curva.curva}>
                        {curva.nome}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Text className="text-muted fs-7">
                    {curvesSource === "api"
                      ? "Catálogo atualizado pelo servidor."
                      : curvesError
                        ? "Catálogo local (API indisponível)."
                        : "Utilize o modelo correto para cada curva"}
                  </Form.Text>
                </Form.Group>
              </Col>
            )}
          </Row>

          <Stack direction="horizontal" gap={3} className="editar-actions-bar justify-content-between flex-wrap">
            <DashMedidasButton
              variant="success"
              className="editar-save-btn"
              onClick={() => {
                handleUpdateEquipment();
                handleUpdateLocal();
              }}
              disabled={!permissionSGU?.home?.write}
            >
              <FaSave /> Salvar alterações
            </DashMedidasButton>
            <Stack direction="horizontal" gap={2}>
              <DashMedidasButton
                variant="outline-primary"
                disabled={!equipamento.cupid}
                onClick={handleCertificateDownload}
                className="text-nowrap"
              >
                <FaDownload /> Baixar certificado
              </DashMedidasButton>

              <DashMedidasButton
                variant="outline-secondary"
                disabled={!access || !permissionSGU?.home?.write}
                onClick={() => handleNavigation(`/config/equipament/${id}`)}
                className="text-nowrap"
              >
                <FaCog /> Acessar equipamento
              </DashMedidasButton>
            </Stack>
          </Stack>

          <Row className="dash-medidas-grid">
            <Col xs={12} md={4}>
              <Card className="shadow-sm detail-card h-100">
                <Card.Body>
                  <h6 className="section-subtitle">Informações Gerais</h6>
                  <InfoRow label="Número de série" value={equipamento.serialnumber} />
                  <InfoRow label="Data de calibração" value={equipamento.dcal} />
                  <InfoRow
                    label="Dias para ativação"
                    value={isNaN(parseInt(equipamento.daystoactivate || "0", 16)) ? 0 : parseInt(equipamento.daystoactivate, 16)}
                  />
                  <InfoRow
                    label="Chip Wi-Fi"
                    value={
                      equipamento.wf === 'OK' ? (
                        <span className="text-success"><FaCheck className="me-1" size={12} />SIM</span>
                      ) : (
                        <span className="text-danger"><FaTimes className="me-1" size={12} />NÃO</span>
                      )
                    }
                  />
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} md={4}>
              <Card className="shadow-sm detail-card h-100">
                <Card.Body>
                  <h6 className="section-subtitle">Identificação</h6>
                  <InfoRow label="ID" value={equipamento.equipid} />
                  <InfoRow label="Sha1 da curva" value={equipamento.sha1curva} truncate />
                  <InfoRow label="ID do copo" value={equipamento.cupid} />
                  <InfoRow
                    label="PH calibrado"
                    value={
                      equipamento.calph === 'OK' ? (
                        <span className="text-success"><FaCheck className="me-1" size={12} />SIM</span>
                      ) : (
                        <span className="text-danger"><FaTimes className="me-1" size={12} />NÃO</span>
                      )
                    }
                  />
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} md={4}>
              <Card className="shadow-sm detail-card h-100">
                <Card.Body>
                  <h6 className="section-subtitle">Versões</h6>
                  <InfoRow label="Firmware principal" value={equipamento.versaofwpri} />
                  <InfoRow label="Firmware osciladora" value={equipamento.versaofwosc} />
                  <InfoRow label="Software" value={equipamento.versaosw} />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </DashMedidasSectionCard>

      {user?.permission?.support?.read && user?.permission?.supportdry?.read && (id.includes("SIMT") || id.includes("SEMT")) && access && (
        <DashMedidasSectionCard
          icon={FaWifi}
          subtitle="Suporte"
          title="Acesso remoto"
          collapsible
          sectionId="dash-acesso-remoto"
          headerRight={
            <DashMedidasButton
              variant={remoteAccessEnabled ? "outline-warning" : "success"}
              onClick={() => setRemoteAccessEnabled(!remoteAccessEnabled)}
            >
              {remoteAccessEnabled ? "Fechar tela" : "Acessar tela"}
            </DashMedidasButton>
          }
          className="editar-remote-card"
        >
          {remoteAccessEnabled && <Conected user={user} serial={id} />}
        </DashMedidasSectionCard>
      )}
    </div>
  );
};

export default EditarEquipamentos;
